export const CURRENCY_OPTIONS = [
  'USD',
  'CAD',
  'GBP',
  'JPY',
  'FRF',
  'DEM',
  'ITL',
  'EUR',
  'ATS',
  'AUD',
  'BEF',
  'BRL',
  'CHF',
  'CLP',
  'CNH',
  'CNY',
  'COP',
  'CZK',
  'DKK',
  'DOP',
  'ESP',
  'FIM',
  'GRD',
  'HKD',
  'HUF',
  'IDR',
  'IEP',
  'INR',
  'KRW',
  'MXN',
  'MYR',
  'NLG',
  'NOK',
  'NZD',
  'PEN',
  'PHP',
  'PLN',
  'PTE',
  'SEK',
  'SGD',
  'SKK',
  'THB',
  'TRY',
  'TWD',
  'ZAR',
  'US Muni. Curve',
]

// Helper function return only the currencies that are not used yet.
export const getAvailableCurrencies = (
  usedCurrencies: string[],
  currentRowIndex: number = -1,
) => {
  const usedCurrencySet = new Set(
    usedCurrencies.filter((_, index) => index !== currentRowIndex),
  )
  return CURRENCY_OPTIONS.filter((currency) => !usedCurrencySet.has(currency))
}
